/**
 * A resposta de `content/los/singleView/{id}`, lida em UM lugar só.
 *
 * POR QUE EXISTE. O endpoint mudou de forma em SCRUM-801 (27/07/2026): devolvia
 * `data: <lo>`, com `path` na raiz, e passou a devolver
 * `data: { los, extra_abilities }`. Nenhum dos consumidores foi migrado — eram 15
 * linhas em 12 arquivos, de cinco frentes diferentes, todas lendo
 * `resp.data.data.path`.
 *
 * O defeito não apareceu como erro de API. Apareceu como "o item não abre":
 * `undefined.match(...)` estoura dentro de um `.then`, o `toastr` de erro não roda
 * (a promessa RESOLVEU, quem falhou foi o callback de sucesso) e o aluno fica
 * olhando um item que não responde. Ficou assim 25 dias, e quem tropeçou foi um
 * item de Link num nó de trilha lúdica, em 21/08/2026.
 *
 * O QUE ESTE MÓDULO GARANTE: a forma da resposta é lida aqui e em nenhum outro
 * lugar. Se ela mudar de novo, quebra UM teste e se conserta em UMA função, em vez
 * de espalhar 15 correções por cinco frentes — ou, pior, de não quebrar nada e o
 * item parar de abrir em silêncio.
 *
 * O backend voltou a mandar os dois formatos (`array_merge` no `singleView`, com
 * `Backend/tests/Unit/Content/LosSingleViewShapeTest.php` travando isso), então
 * hoje os dois caminhos funcionam. Este módulo aceita os dois de propósito: é o
 * que faz a correção do frontend e a do backend não dependerem uma da outra para
 * subir.
 */

/**
 * O objeto do LO, qualquer que seja o formato da resposta.
 *
 * Prefere `data.los` quando ela existe porque é a estrutura DOCUMENTADA hoje; a
 * raiz é o fallback de compatibilidade. Devolve um objeto vazio, e não `null`,
 * para o consumidor poder ler um campo sem checar nada antes — foi ler direto que
 * causou o defeito, então o caminho seguro tem de ser o caminho preguiçoso.
 *
 * @param {object} resposta o `resp` do axios
 * @returns {object} o LO, ou `{}` se a resposta não trouxer nenhum
 */
export function loDaResposta(resposta) {
  const dados = resposta && resposta.data && resposta.data.data;
  if (!dados || typeof dados !== "object") return {};
  if (dados.los && typeof dados.los === "object") return dados.los;
  return dados;
}

/**
 * O caminho (URL ou arquivo) do LO.
 *
 * Devolve string SEMPRE — `""` quando não há caminho. É o que permite
 * `caminhoDoLo(resp).match(...)` e `.toLowerCase()` sem guarda: um LO de link sem
 * `path` é dado ruim, e dado ruim não pode virar tela branca.
 *
 * @param {object} resposta o `resp` do axios
 * @returns {string}
 */
export function caminhoDoLo(resposta) {
  const caminho = loDaResposta(resposta).path;
  return typeof caminho === "string" ? caminho : "";
}
